var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1311_3103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0.767578C3.58862 0.767578 0 4.3562 0 8.76758C0 13.179 3.58862 16.7676 8 16.7676C12.4114 16.7676 16 13.179 16 8.76758C16 4.3562 12.4114 0.767578 8 0.767578Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.946 10.7708C11.2066 11.0315 11.2066 11.4528 10.946 11.7135C10.8159 11.8435 10.6453 11.9088 10.4745 11.9088C10.3039 11.9088 10.1332 11.8435 10.0032 11.7135L7.99991 9.71011L5.99661 11.7135C5.86661 11.8435 5.69595 11.9088 5.5253 11.9088C5.35452 11.9088 5.18387 11.8435 5.05386 11.7135C4.79324 11.4528 4.79324 11.0315 5.05386 10.7708L7.05728 8.76749L5.05386 6.76419C4.79324 6.50345 4.79324 6.08218 5.05386 5.82144C5.31461 5.56082 5.73587 5.56082 5.99661 5.82144L7.99991 7.82486L10.0032 5.82144C10.2639 5.56082 10.6852 5.56082 10.946 5.82144C11.2066 6.08218 11.2066 6.50345 10.946 6.76419L8.94254 8.76749L10.946 10.7708Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1311_3103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.767578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductInactive);
export default __webpack_public_path__ + "static/media/ProductInactive.bbe8dd385621dbb623e0154cfe3a44f7.svg";
export { ForwardRef as ReactComponent };